import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MedicineBoxOutlinedSvg from "@ant-design/icons-svg/es/asn/MedicineBoxOutlined";
import AntdIcon from "../components/AntdIcon";
var MedicineBoxOutlined = function MedicineBoxOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MedicineBoxOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MedicineBoxOutlined.displayName = 'MedicineBoxOutlined';
}
export default /*#__PURE__*/React.forwardRef(MedicineBoxOutlined);